module.exports = __webpack_public_path__ + "static/LobbyImage-4b1e6f912a41dacbd747b26564e7a6a2.jpg";